import { IntegrationType, UserStatusTypes } from "types"
import { parseAwsTokenToObject } from "utils/helper"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"

export type UserInfo = {
  integrationType: IntegrationType
  username: string
  groups: string[]
  merchantId: string
  status: UserStatusTypes
  userExpired?: boolean
}

export interface IUserState {
  userInfo: UserInfo
  customPhoto: string | null
  token?: {
    awsAccessKey: string
    awsJwtToken: string
    awsSecretAccessKey: string
  }
}

const initialState: IUserState = {
  userInfo: {
    integrationType: IntegrationType.COMMON,
    username: "",
    groups: [],
    merchantId: "",
    status: UserStatusTypes.NEW,
    userExpired: false,
  },
  customPhoto: null,
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAwsToken: (state, action: PayloadAction<string>) => {
      state.token = parseAwsTokenToObject(action.payload)
    },
    setUserInfo: (state, action: PayloadAction<Pick<IUserState, "userInfo">>) => {
      state.userInfo = action.payload.userInfo
    },
    setUserStatus: (state, action: PayloadAction<UserStatusTypes>) => {
      state.userInfo.status = action.payload
    },
    userExpired: (state) => {
      state.userInfo = {
        ...state.userInfo,
        integrationType: state.userInfo.integrationType,
        userExpired: true,
      }
    },
    clearUserInfo: (state) => {
      state.userInfo = initialState.userInfo
      state.token = undefined
    },
    setCustomPhoto: (state, action: PayloadAction<string | null>) => {
      state.customPhoto = action.payload
    },
  },
})

export const {
  setUserInfo,
  clearUserInfo,
  setAwsToken,
  setUserStatus,
  userExpired,
  setCustomPhoto,
} = userSlice.actions

export const selectUser = (state: RootState) => state.user
export const selectUserInfo = (state: RootState) => state.user.userInfo

export default userSlice.reducer
